import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgItemRemove = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		style: { fill: "none" },
		fill: "none",
		d: "M12 4L4 12M4 4L12 12",
		stroke: "#333333",
		strokeWidth: 1.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgItemRemove;
